import React from 'react';
import locales from '../../../content.json';
import { getParameterFromURL } from '../../../utils/scripts';

import bg_webp from './img/bg.webp';
import bg_png from './img/bg.png';
import bg_webp_dark from './img/bgDark.webp';
import bg_jpg_dark from './img/bgDark.jpg';
import icon1 from './img/icon1.png';
import icon2 from './img/icon2.png';
import icon3 from './img/icon3.png';

import s  from './index.module.scss';

export const MainScreenV2 = () => {
  const darkTheme = getParameterFromURL('darkTheme') === 'true';
  return(
    <div className={s.mainScreen}>
      <img className={s.icon} src={icon1} alt='icon'/>
      <img className={s.icon} src={icon2} alt='icon'/>
      <img className={s.icon} src={icon3} alt='icon'/>
      <h2 className={s.title}>{locales[window.userLang].payment_text_30}</h2>
      <picture>
          <source srcSet={darkTheme ? bg_webp_dark : bg_webp} type="image/webp" />
          <img src={darkTheme ? bg_jpg_dark : bg_png} alt="header image" />
      </picture>
    </div>
  )
}

